import axios from 'axios';
import { SOLUCIONARE_ERRORS } from '../../constants/Errors';
import {
  IResponseProcessResultSolucionare,
  IResponseStatusSolucionare,
} from '../../types/entities';
import { SolucionareErrors } from '../../types/enums';

const BASE_URL =
  'https://cors-anywhere.herokuapp.com/http://online.solucionarelj.com.br:9090/WebApiDiscoveryFullV2/api/DiscoveryFull/';

export const authenticate = async (relationalName: string, token: string) =>
  new Promise<string | SolucionareErrors>((resolve) => {
    axios
      .post(`${BASE_URL}autenticaAPI`, {
        nomeRelacional: relationalName,
        token,
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        const typeError = SOLUCIONARE_ERRORS[error.response.data];
        return typeError;
      });
  });

export const getStatusSearch = async (codeSearch: string, token: string) =>
  new Promise<IResponseStatusSolucionare>((resolve, reject) => {
    axios
      .post(
        `${BASE_URL}buscaStatusPesquisa`,
        {
          codPesquisa: [codeSearch],
        },
        { headers: { Authorization: token } },
      )
      .then(({ data }) => {
        resolve(data);
      })
      .catch(reject);
  });
export const insertSearchByNumberProcess = async (numberProcess: string, token: string) =>
  new Promise<number>((resolve, reject) => {
    axios
      .post(
        `${BASE_URL}CadastraPesquisa_NumProcessos`,
        {
          numeroProcesso: numberProcess,
        },
        { headers: { Authorization: token } },
      )
      .then(({ data }) => {
        resolve(data);
      })
      .catch(reject);
  });

export const getResultSearchByCode = async (codeSearch: string, token: string) =>
  new Promise<IResponseProcessResultSolucionare>((resolve, reject) => {
    axios
      .post(
        `${BASE_URL}buscaDadosResultadoPesquisa`,
        {
          codPesquisa: codeSearch,
        },
        { headers: { Authorization: token } },
      )
      .then(({ data }) => {
        resolve(data);
      })
      .catch(reject);
  });
